import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TopicService } from '../topic.service';
import { CryptoService } from '../crypto.service';
import { CryptoView } from '../crypto-view';
import { map } from 'rxjs/operator/map';
import { NgModelGroup } from '@angular/forms';
@Component({
  selector: 'app-skytale',
  templateUrl: './skytale.component.html',
  styleUrls: ['../topic-style.css', './skytale.component.css']
})
export class SkytaleComponent extends CryptoView {
  private _key: number;
  @Input()
  set key(value: number) {
    if (!value || value == 0) {
      value = undefined;
    }
    if(value > 10){
      value = 10;
    }
    this._key = value;
    this.inputs = undefined;
    let text = this.text;
    this.text = "";
    this.text = text;
  }

get key(): number {
  return this._key;
}

@Input()
set current(value: string) {
  //console.log(value);
  //console.log(this.key);
  if (this.direction == "encode") {
    this.currentRow = Math.floor(+value / this.key);
    this.currentColumn = +value - (Math.floor(+value / this.key) * this.key);
  } else {
    this.currentRow = Math.floor(+value % this.rows)
    this.currentColumn = (Math.floor(+value / this.rows));
  }
  //console.log(this.currentColumn);
  //console.log(this.currentRow);
}
@Input() modus: string;
@Input() direction: string;
  private _text: string;
@Input()
set text(value: string) {
  console.log(value)
  this._text = value;
  if (!value) {
    return;
  }
  value = value.replace(/-/gi, " ");
  this.rows = Math.ceil(value.length / this.key);
  this.textd = [];
  if (this.direction == 'encode') {
    for (let i = 0; i < this.key; i++) {
      this.textd.push([]);
      for (let j = 0; j < this.rows; j++) {
        this.textd[i].push(value.charAt(this.rows * i + j));
      }
    }
  } else {
    this.textd = [];
    for (let i = 0; i < this.key; i++) {
      this.textd.push([]);
    }

    for (let i = 0; i < this.rows; i++) {
      for (let j = 0; j < this.key; j++) {
        this.textd[j].push(value.charAt(this.key * i + j));
      }
    }
  }

  if (this.key && this.rows && !this.inputs) {
    this.inputs = [];
    for (let i = 0; i < this.key; i++) {
      this.mapping = this.mapping.concat(" ".repeat(this.text.length));
      if (this.mapping) {
        this.inputs.push(this.mapping.substr(i * this.rows, this.rows).split(""));
      } else {
        this.inputs.push([]);
        for (let j = 0; j < this.rows; j++) {
          this.inputs[i].push(" ");
        }
      }
    }
  }
  this.changeMapping();
}

get text(): string {
  return this._text;

}
@Output() studentKey = new EventEmitter<number>();
@Output() focus = new EventEmitter<number>();

inputs: string[][];
textd: string[][];
rows: number;

currentRow: number;
currentColumn: number;

mapping: string = "";

constructor(topicService: TopicService, protected cryptoService: CryptoService) {
  super(topicService);
  this.inputs = undefined;
}

/** returns the student mapping */
getMapping() {
  if(!this.inputs){
    return undefined;
  }
  return this.inputs.map(v => v.map(w => w ? w : " ")).map(v => v.join("")).join("");
}

/** sets the mapping */
setmapping(mapping: string) {
  if (!this.key || !this.text) {
    this.inputs = undefined;
    this.mapping = mapping;
    return;
  }
  if (this.inputs) {
    for (let i = 0; i < this.text.length / this.key; i++) {
      for (let j = 0; j < this.key; j++) {
        this.inputs[j][i] = mapping.charAt(i * this.rows + j)
      }
    }
  } else {
    this.mapping = mapping;
  }
}

/** when mapping changes */
changeMapping() {
  if (this.mapping != "" && this.mapping.length == this.text.length) {
    let map = this.getMapping();
    this.setmapping(map);
  }
}

/** resets the mapping */
resetmapping() {
  this.mapping = "";
  if (this.text) {
    this.setmapping(" ".repeat(this.text.length));
  }
}

/** sets the hint */
setHints(hints: string[]) {
}

/** fills the mapping */
fillMapping() {
  this.inputs = this.textd;
}

/** emity the current position */
onFocus(i: number, j: number){
  if (this.direction == "encode") {
    this.focus.emit(i * this.rows + j);
  } else {
    this.focus.emit(j * this.key + i)
  }
}

/** emits the new key */
changeKey(){
  this.studentKey.emit(this.key);
  this.current = "0";
}


}
